/**
 * Mirrors tungkai's isFeatureEnabledForUser.ts exactly (same config.tungKai.featureFlags
 * shape) so a whitelist rollout can't fall out of sync between the two apps.
 *
 * @param {{ enabled: boolean, whitelistEnabled?: boolean, userIds: string[] }} [feature] - `enabled: false` = off for everyone; `whitelistEnabled` overrides the shared flag for this feature alone
 * @param {string} [userId]
 * @param {{ whitelistEnabled: boolean, globalUserIds: string[] }} access
 * @returns {boolean}
 */
export const isFeatureEnabled = (feature, userId, access) => {
  if (!feature?.enabled) {
    return false;
  }

  // A feature can opt out of the shared whitelist on its own, so one feature can go GA while
  // another stays gated — whitelistEnabled is shared by every feature otherwise.
  const isWhitelistRolloutOff = !(feature.whitelistEnabled ?? access?.whitelistEnabled);
  if (isWhitelistRolloutOff) {
    return true;
  }

  if (userId && access.globalUserIds?.includes(userId)) {
    return true;
  }

  return Boolean(userId && feature.userIds?.includes(userId));
};
